import { Vue, Component, Emit, Watch } from 'vue-property-decorator'

@Component
export default class RightVessel extends Vue {

    currentActiveImageIndex: number = 0;
    backgroundImages: any = [
        {
            imageNumber: '01',
            active: false
        },
        {
            imageNumber: '02',
            active: false
        },
        {
            imageNumber: '03',
            active: false
        },
        {
            imageNumber: '04',
            active: false
        }
    ];

    currentActiveImageIndexUpdate(index: number): void
    {
        this.currentActiveImageIndex = index;
    }

    changeBackgroundImage(): void
    {
        setInterval(() => {
            this.backgroundImages[this.currentActiveImageIndex].active = false;

            if (this.currentActiveImageIndex === 3)
            {
                this.currentActiveImageIndex = 0;
                this.backgroundImages[0].active = true;
            }
            else
            {
                this.currentActiveImageIndex++;
                this.backgroundImages[this.currentActiveImageIndex].active = true;
            }

        }, 10000);
    }

    setImageToActive(index: number): void
    {
        this.backgroundImages[this.currentActiveImageIndex].active = false;
        this.currentActiveImageIndex = index;
        this.backgroundImages[this.currentActiveImageIndex].active = true;
    }

    created(): void
    {
        this.backgroundImages[this.currentActiveImageIndex].active = true;
        this.changeBackgroundImage();
    }

    @Watch('currentActiveImageIndex')
    @Emit('currentActiveImageIndex')
    emitCurrentActiveImageIndex(currentActiveImageIndex: number): void
    {
        // emit active image index
    }
}
